// extracted by mini-css-extract-plugin
export var author = "recipe-ingredient-list-module--author--6738e";
export var header = "recipe-ingredient-list-module--header--61fde";